import { createTheme } from "@mui/material";
import { themeColors } from "app/components/MatxTheme/themeColors";
import themeOptions from "app/components/MatxTheme/themeOptions";
import { forEach, merge } from "lodash";

function createMatxThemes() {
  let themes = {};

  forEach(themeColors, (value, key) => {
    themes[key] = createTheme(merge({}, themeOptions, value));
  });

  return themes;
}
export const themes = createMatxThemes();
